import data from "./country_list.json";

const country_code_options = data.map(({ code,name_pl }) => ({
  label: `${name_pl} (${code})`,
  value: code,
}));

export default country_code_options;
